import React, {Component} from 'react';

import {Button, Intent, Menu, MenuItem, Popover, PopoverInteractionKind, Position, Tag} from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";

const optionsPageSize = [

    {value: 10, text: 10},
    {value: 25, text: 25},
    {value: 50, text: 50}
];


class ItemsPerPage extends Component {



    async componentDidMount() {
    }


    pageSizeItemRenderer = (item, {modifiers, handleClick}) => {
        //{console.log('item: ',item)}
        return (

            <MenuItem
                key={item.text}
                text={item.text}
                value={item.value}
                active={modifiers.active}
                shouldDismissPopover={true}
                onClick={handleClick}
            />
        )
    };
    pageSizeItemSelect = async (item) => {
        await this.props.handleItemChange(item)
    }

    render() {
        return (

            <div className="subscribers-per-page">
                <p>Items shown per page</p>

                <Select
                    items={optionsPageSize}
                    itemRenderer={this.pageSizeItemRenderer}
                    onItemSelect={this.pageSizeItemSelect}
                    filterable={false}
                >
                    <Button text={this.props.selectedPageSize}></Button>

                </Select>
            </div>
        )
    }
}

export default ItemsPerPage